var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.room.code == null)?_c('Lobby',{on:{"create-room":_vm.createRoom,"join-room":_vm.joinRoom}}):_c('Game',{attrs:{"room":_vm.room,"name":_vm.name},on:{"leave-room":_vm.leaveRoom}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }